import { render, staticRenderFns } from "./CarbonFootprintAgreeDialog.vue?vue&type=template&id=9faa1b4c&scoped=true"
import script from "./CarbonFootprintAgreeDialog.vue?vue&type=script&lang=js"
export * from "./CarbonFootprintAgreeDialog.vue?vue&type=script&lang=js"
import style0 from "./CarbonFootprintAgreeDialog.vue?vue&type=style&index=0&id=9faa1b4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9faa1b4c",
  null
  
)

export default component.exports